  import React, { useEffect, useState } from "react";
  import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
  import backicon from "./../../../../../../Assets/icons/backIcon.svg";
  import { useLocation, useNavigate } from "react-router-dom";
  import ROUTES_NAVIGATION from "../../../../../../routes/routes";
  import axiosInstance from "../../../../../services/api/API";
  import { toastError, toastSuccess } from "../../../../../customComponents/customToast/Toast";
  import "react-toastify/dist/ReactToastify.css";
  import { ToastContainer } from "react-toastify";
  import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
  import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
  
  const EditAgentCustomerForm = () => {
      const [formData, setFormData] = useState({});
      const [fileNames, setFileNames] = useState({});
      const [images,setImages] = useState([])
      const [ configformData, setConfigformdata ] = useState({})
      const [ uploadDocumentFormData, setuploadDocumentFormData ] = useState({})
      const [ accessModule, setAccessModule ] = useState({})
      const location = useLocation();
      const { data } = location.state || {};
      const [responseerrormessage,setResponseErrorMessage] = useState('')
  
      console.log(data, "OnBoardDataVal")
      
    const [activeSection, setActiveSection] = useState('Customer');
  
    const [onBoardId, setOnboardId] = useState(null);
  
    const [onboardProcessType, setOnboardProcessType] = useState('');
  
    const [ fetchCongfigData, setFetchConfigData ] = useState([])
    const [ fetchUploadDocumentData, setfetchUploadDocumentData ] = useState([])
    const [ fetchOnboardDetails, setfetchOnboardDetails ] = useState([])
  
    const [ ONBoardStatus, setOnBoardStatus ] = useState(null)
  
    const [ isButtonVisible, setIsButtonVisible ] = useState(true)
    const [ isBpApproved, setIsBpApproved ] = useState(false)
  
    const [showAdditionalInputs, setShowAdditionalInputs] = useState(true);
  
    const [ onBoardType, setOnBoardType ] = useState("Agent")
  
    const [ menuDropdown, setMenuDropdown ] = useState([])
  
    const [isFormSubmittedSuccessfully, setIsFormSubmittedSuccessfully] = useState(false);
    const token = localStorage.getItem("authToken");
  
    console.log(token, "TOKEN")
  
    const authToken = localStorage.getItem("authToken");
    console.log(authToken, "AUTHTOKEN")
  
    const [businessPartnertypedd, setBusinessPartnerTypedd] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [validationErrors, setValidationErrors] = useState({});
  
  
    console.log(data, "DAATAONBOARD")
  
    const navigate = useNavigate();
    const handleNavigate = () => {
      navigate('/admin/manage-onboard/onboard/create-customer');
    };
  
    // useEffect(() => {
    //   // Set the default value for action to "2" (Approve)
    //   setAccessModule((prev) => ({
    //     ...prev,
    //     action: "Approve",
    //   }));
    // }, []);
  
    useEffect(() => {
      fetchMenuDropdown();
    },[])
  
    useEffect(() => {
  
      fetchCongfig()
    },[])
  
    useEffect(() => {
      fetchDocuments()
      fetchOnBoardDetails()
    },[])
  
    const fetchOnBoardDetails = async () => {
      try{
        const response = await axiosInstance.get(`/bp-onboard/edit/${data.onboard_id}`,{
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        })
  
        const fetchedData = response.data.data
        const transformedData = {
          onboard_process_type: fetchedData.onboard_process_type,
          bp_type:fetchedData.bp_type,
          bp_name:fetchedData.bp_name,
          contact_no:fetchedData.contact_no,
          email_id:fetchedData.email_id,
          pincode:fetchedData.pincode,
          city_id:fetchedData.city_id,
          country_id:fetchedData.country_id,
          state_id:fetchedData.state_id,
          bp_address:fetchedData.bp_address,
          gst_no:fetchedData.gst_no,
          status: fetchedData.status,
          onboard_level:fetchedData?.onboard_status
        }
        setFormData(transformedData)
  
        const accessModuleData = {
          accessModule:fetchedData.menu_access,    
          remark:fetchedData.remark,
          onboard_level: fetchedData.onboard_status 
  
        }
        setAccessModule(accessModuleData)
  
        console.log(fetchedData, "fetchConfigData")
        console.log(transformedData, "TRANSFORMEDDATA")
  
        const onboardid=fetchedData?.onboard_id
        const onBoardStatus = fetchedData?.onboard_status
        setOnBoardStatus(onBoardStatus)
        setOnboardId(onboardid);
        onBoardStatus ==3 ? setIsBpApproved(true) : setIsBpApproved(false);

        const onObType = fetchedData?.onboard_process_type;
        setOnboardProcessType(onObType);
  
        setfetchOnboardDetails(fetchedData)
      }catch(error){
        console.log(error, "error")
      }
    }
  
    const fetchDocuments = async () => {
      try{
        const response = await axiosInstance.get(`/bp-onboard/getDocument/${data.onboard_id}`,{
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        })
        const fetchedData = response.data.data.data
        const transformedData = {
          adhaarcard: null,
          pan: null,
          cancelcheque: null,
          agreementcopy: null,
          businesslicense: null,
          environmentalpolicy: null,
        };
    
        fetchedData.forEach(doc => {
          switch (doc.document_type) {
            case 1:
              transformedData.adhaarcard = doc.image_path;
              break;
            case 2:
              transformedData.pan = doc.image_path;
              break;
              case 3:
                transformedData.cancelcheque = doc.image_path;
                break;
                case 4:
                  transformedData.agreementcopy = doc.image_path;
                  break;
                  case 5:
                  transformedData.businesslicense = doc.image_path;
                  break;
                  case 6:
                  transformedData.environmentalpolicy = doc.image_path;
                  break;
            default:
              break;
          }
        });
  
        setuploadDocumentFormData(transformedData)
        setImages(transformedData)
        
        console.log("uploadDocumentForm>>>",uploadDocumentFormData);
        setfetchUploadDocumentData(fetchedData)
      }catch(error){
        console.log(error, "error")
      }
    }
  
    const fetchCongfig = async () => {
      try{
        const response = await axiosInstance.get(`/bp-onboard/getConfig/${data.onboard_id}`,{
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        })
  
        const fetchedConfigData = response.data.data.data
        console.log(fetchedConfigData, "FETCHEDDATA")
        let transformedData = {};
        if (Array.isArray(fetchedConfigData) && fetchedConfigData.length > 0) {
          transformedData = {
            max_hierarchy_level: fetchedConfigData[0].max_hierarchy_level,
            total_user: fetchedConfigData[0].total_user,
            user_prefix: fetchedConfigData[0].user_prefix,
          };
          setFetchConfigData(fetchedConfigData[0]); 
        } else if (typeof fetchedConfigData === 'object' && fetchedConfigData !== null) {
          transformedData = {
            max_hierarchy_level: fetchedConfigData.max_hierarchy_level,
            total_user: fetchedConfigData.total_user,
            user_prefix: fetchedConfigData.user_prefix,
          };
          setFetchConfigData(fetchedConfigData); 
        } else {
          console.error("Fetched config data is not in the expected format.");
          return; 
        }
        setConfigformdata(transformedData)
        setFetchConfigData(fetchedConfigData)
        
      }catch(error){
        console.log(error, "error")
      }
    }
  
    const fetchMenuDropdown = async () => {
      try {
        const response = await axiosInstance.get('/bp-onboard/menu',{
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        });
  
        const formattedData = response.data.data.data
        const menuOptions = formattedData.map(item => ({
          value: item.menu_id,
          label: item.menu_name,
        }));
        setMenuDropdown(menuOptions);
        console.log(formattedData, "MENU DROPDOWN DATA")
  
      } catch (error) {
        console.error('Error fetching campaign list:', error);
      }
    };
  
    const handleFormSubmit = async ({...formData}) => {
      console.log("formDataHandleSubmit",formData);
  
      const errors = {};
      let isValid = true;
  
      CustomerInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }
        }
      });
      ConfigInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }
        }
      });
      AccessModule.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }
        }
      });
  
      if (!isValid) {
        setValidationErrors(errors);
        return;
      }
  
      setIsLoading(true);
  
      console.log("clicked")
      try {
        const response = await axiosInstance.post("/bp-onboard/create", {
          onboard_process_type: formData.onboard_process_type,
          bp_type: formData.business_partner_type,
          bp_name: formData.bp_name,
          contact_no: formData.contact_no,
          email_id: formData.email_id,
          pincode: formData.pincode,
          city_id: formData.city_id,
          country_id: formData.country_id,
          state_id: formData.state_id,
          bp_address: formData.bp_address,
          gst_no: formData.gst_no,
          // onboard_status:formData.onboard_status,
          status: formData.status.value === "Active" ? 1 : 0,
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        });
  
        if (response.status === 200) {
          // Call uploadDocumentForm after successful configForm submission
          // await createUpdateAcess(formData);
        }
  
        console.log("APIResponse", response.data?.data);
        const onboardid=response?.data?.data?.onboard_id
        const onBoardStatus = response?.data?.data?.onboard_status
        setOnBoardStatus(onBoardStatus)
        console.log(onBoardStatus, "onBoardSttaus")
        setOnboardId(onboardid);
        console.log("onboardid>>>",onboardid);
        //setcreateOnBoardStatus(resposne.data)
        // toastSuccess("Product added successfully!");
        setIsFormSubmittedSuccessfully(true)
        setIsButtonVisible(false)
  
      } catch (error) {
        console.log(error, "error")
        // toastError("Failed to add . Please try again.");
      } finally {
        setIsLoading(false)
      }
    }
    
  
  
    const handleConfig = async (configformData) => {
      const errors = {};
      let isValid = true;
    console.log("configformData",configformData);
    
      // Validate form fields
      ConfigInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!configformData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          } else if (
            field.required &&
            field.validation &&
            field.validation.pattern &&
            !field.validation.pattern.test(configformData[field.name])
          ) {
            errors[field.name] = field.validation.message;
            isValid = false;
          }
        }
      });
      console.log("Access Module",accessModule);
      
      AccessModule.forEach((field) => {
        console.log("accessmodulefields", field);
        
        if (field.validation && field.validation.required) {
          const value = accessModule[field.name];
          console.log("fieldsaccess", value);
      
          // Check if the value is undefined, null, empty string, or empty array
          if (!value || (Array.isArray(value) && value.length === 0)) {
            errors[field.name] = "This field is required";
            isValid = false;
          } else if (
            field.validation.pattern &&
            !field.validation.pattern.test(value)
          ) {
            errors[field.name] = field.validation.message;
            isValid = false;
          }
        }
      });
      
    
      // If validation fails, set errors and return
      if (!isValid) {
        setValidationErrors(errors);
        return;
      }
      showCustomAlert({
          title: "Customer Added Successfully",
          text: "Are you sure you want to update?",
          icon: "success",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          callback: async () => {
  
      try {
  
        // Log the payload to be sent
      const payload = {
        max_hierarchy_level: configformData.max_hierarchy_level,
        total_user: configformData.total_user,
        user_prefix: configformData.user_prefix,
      };
      console.log("Payload to be sent:", payload);
  
        const response = await axiosInstance.patch(`/bp-onboard/updateConfig/${data.onboard_id}`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        });
  
        console.log("API Response:", response.data);
  
        console.log(response.status, "RESPOSNE STATUS")
        if (response.status == 200) {
          // alert("hello")
         await updateForm(formData)
          // Call uploadDocumentForm after successful configForm submission
          await createUpdateAcess(accessModule);
  
          await uploadDocumentForm(uploadDocumentFormData)
        }
  
        
  
        if (response.status === 200) {
   
          navigate("/admin/manage-onboard/onboard")
  
    }
  
      } catch (error) {
        console.log(error, "error")
        const errorMessage = error.response?.data?.message
  
        showErrorAlert({
      title: "Something went wrong",
      text: errorMessage || "An error occurred while processing your request.",
      callback: () => { 
        // Optional: code to execute after confirming the alert
        console.log("Error alert confirmed");
      }
    });
        // toastError("Failed to add . Please try again.");
      } finally {
        setIsLoading(false)
      }
  },
  });
    }
  
    // const updateForm = async (formData) => {
    //   console.log(formData, "FORMDATA")
  
    //   try{
    //     const onboard_status = 1
  
        
  
    //     const payload = {
    //       onboard_process_type: formData.onboard_process_type,
    //       onboard_status,
    //       bp_type: formData.bp_type,
    //       bp_name: formData.bp_name,
    //       contact_no: formData.contact_no,
    //       email_id: formData.email_id,
    //       pincode: formData.pincode,
    //       city_id: formData.city_id,
    //       country_id: formData.country_id,
    //       state_id: formData.state_id,
    //       bp_address: formData.bp_address,
    //       gst_no: formData.gst_no,
    //       status: formData.status === 1 ? 1 : 0,
    //     }
    //     const response = await axiosInstance.patch(`/bp-onboard/update/${data.onboard_id}`,payload, {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${authToken}`,
    //       }
    //     })
  
        
  
    //     if (response.status === 200) {
    //       // Call uploadDocumentForm after successful configForm submission
  
    //       await handleConfig(configformData)
    //       // await createUpdateAcess(accessModule);
    //     }
    //     console.log(response.data, "UPDATEFORM")
    //   }catch(error){
    //     console.log(error, "error")
    //   }
    // }
  
    const updateForm = async (formData) => {
  console.log("formdataapproval",formData);
  
      const errors = {};
      let isValid = true;
    
      // Validate form fields
      CustomerInputs.forEach((field) => {
        if (field.validation) {
          if (field.name === "status" && formData.status === 0) {
            // Specific validation logic for status field if needed
          } else if (field.validation.required && !formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          } else if (field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
            errors[field.name] = field.validation.message;
            isValid = false;
          }
        }
      });

   
     
      console.log(errors, "<<>>onboardiduuper<<>>");
      // If validation fails, set errors and return
      if (!isValid) {
        setValidationErrors(errors);
        return;
      }
    
      setIsLoading(true);
      console.log(formData, "<<>>onboarddata<<>>");
    
      // SweetAlert confirmation before submission
     
          try {
           // const onboard_status = 1;
    
            const payload = {
              onboard_process_type: formData.onboard_process_type,
              bp_type: formData?.bp_type,
              bp_name: formData.bp_name,
              contact_no: formData.contact_no,
              email_id: formData.email_id,
              pincode: formData.pincode,
              city_id: formData.city_id,
              country_id: formData.country_id,
              state_id: formData.state_id,
              bp_address: formData.bp_address,
              gst_no: formData.gst_no,
              status: formData.status === 1 ? 1 : 0,
            };
    
            // API request to update the form data
            const response = await axiosInstance.patch(
              `/bp-onboard/update/${data.onboard_id}`,
              payload,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${authToken}`,
                },
              }
            );
    
          //   await handleConfig(configformData);
          //   if (response.status === 200) {
          //   }
    
            console.log(response.data, "UPDATEFORM");
          } catch (error) {
            console.log(error, "error");
    
            // Error handling with SweetAlert
         
          }
  
    };
    
  
    const createUpdateAcess = async (formData) => {
  
      console.log(formData, "FORMDATAA")
      // const menuAccessIds = formData.accessModule.join(",")
      let menuAccessIds;
    if (Array.isArray(formData.accessModule)) {
      menuAccessIds = formData.accessModule.join(",");
    } else {
      menuAccessIds = formData.accessModule;
    }
      console.log(menuAccessIds, "menuaccessid")
  
      const payload = {
        menu_access: menuAccessIds,
        onboard_status:formData?.onboard_level,
        remark:formData.remark,
  
      }
      console.log(payload, "UpdateAccess Payload")
      try {
        const resposne = await axiosInstance.patch(`/bp-onboard/updateAccess/${data.onboard_id}`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        })
  
        console.log(resposne.data, "Api Resposne:")
      }catch (error) {
        console.log("ERROR", error)
        // toastError("Failed to add product. Please try again.");
      } finally {
        setIsLoading(false)
      }
    }
  
  
    // const uploadDocumentForm =  async() => {
    // const uploadData = new FormData();
  
    // uploadData.append("document_type","1,2,3,4,5,6")
    // uploadData.append('onboard_bp_id', onBoardId);
  
    // if (uploadDocumentFormData.adhaarcard) {
    //   uploadData.append('uploadFile', uploadDocumentFormData.adhaarcard);
    // }
    // if (uploadDocumentFormData.pan) {
    //   uploadData.append('uploadFile', uploadDocumentFormData.pan);
    // }
    // if (uploadDocumentFormData.cancelcheque) {
    //   uploadData.append('uploadFile', uploadDocumentFormData.cancelcheque);
    // }
    // if (uploadDocumentFormData.agreementcopy) {
    //   uploadData.append('uploadFile', uploadDocumentFormData.agreementcopy);
    // }
    // if (uploadDocumentFormData.businesslicense) {
    //   uploadData.append('uploadFile', uploadDocumentFormData.businesslicense);
    // }
    // if (uploadDocumentFormData.environmentalpolicy) {
    //   uploadData.append('uploadFile', uploadDocumentFormData.environmentalpolicy);
    // }
  
    //   try {
    //     const response = await axiosInstance.post('/bp-onboard/uploadDocument',uploadData, 
    //     {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //         Authorization: `Bearer ${authToken}`,
    //       }
    //     }
    //   );
    
    //     console.log("added successfully:", response.data);
    //     //toastSuccess("Product Data fetched successfully!"); 
    //     navigate("") 
    //   } catch (error) {
    //     console.error('Error adding unit:', error);
    //     // toastError("Failed to add product. Please try again.");
    //     console.error("Error submitting form:", error);
    //   }
    //   // const response = await axiosInstance.post("")
  
    // }

    const uploadDocumentForm = async () => {
      const uploadData = new FormData();
      const documentTypes = [];
    
      // Check if adhaarcard is a file (new document) and append it
      if (uploadDocumentFormData.adhaarcard instanceof File) {
        uploadData.append('uploadFile', uploadDocumentFormData.adhaarcard);
        documentTypes.push(1); // Assuming 1 is for Aadhaar card
      }
    
      // Check if pancard is a file and append it
      if (uploadDocumentFormData.pan instanceof File) {
        uploadData.append('uploadFile', uploadDocumentFormData.pan);
        documentTypes.push(2); // Assuming 2 is for PAN card
      }
    
      // Check if cancelcheque is a file and append it
      if (uploadDocumentFormData.cancelcheque instanceof File) {
        uploadData.append('uploadFile', uploadDocumentFormData.cancelcheque);
        documentTypes.push(3); // Assuming 3 is for Cancel Cheque
      }
    
      // Check if agreementcopy is a file and append it
      if (uploadDocumentFormData.agreementcopy instanceof File) {
        uploadData.append('uploadFile', uploadDocumentFormData.agreementcopy);
        documentTypes.push(4); // Assuming 4 is for Agreement Copy
      }
    
      // Check if businesslicense is a file and append it
      if (uploadDocumentFormData.businesslicense instanceof File) {
        uploadData.append('uploadFile', uploadDocumentFormData.businesslicense);
        documentTypes.push(5); // Assuming 5 is for Business License
      }
    
      // Check if environmentalpolicy is a file and append it
      if (uploadDocumentFormData.environmentalpolicy instanceof File) {
        uploadData.append('uploadFile', uploadDocumentFormData.environmentalpolicy);
        documentTypes.push(6); // Assuming 6 is for Environmental Policy
      }
    
      // Only proceed if there are files to upload
      if (documentTypes.length > 0) {
        // Add document types as a comma-separated string
        uploadData.append("document_type", documentTypes.join(','));
        uploadData.append('onboard_bp_id', onBoardId);
    
        try {
          const response = await axiosInstance.post('/bp-onboard/uploadDocument', uploadData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${authToken}`,
            }
          });
    
          console.log("Added successfully:", response.data);
          navigate(""); 
        } catch (error) {
          console.error('Error adding unit:', error);
          console.error("Error submitting form:", error);
        }
      } else {
        console.log("No new documents to upload.");
      }
    };
  
    const fetchBusinessPartnerType = async () => {
      try {
        const resposne = await axiosInstance.post("/businesspartnertype/ddlbusinesspartnertype", {}, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        })
        const options = resposne.data.data.data.map(data => ({
          label: data.NAME,
          value: data.ID,
        }));
  
        setBusinessPartnerTypedd(options)
  
      } catch (error) {
        console.log(error)
      }
    }
  
    useEffect(() => {
      fetchBusinessPartnerType();
    }, [])
  
    const ConfigInputs = [
      {
        name: "max_hierarchy_level",
        label: "Max Hierarchy Level",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true,maxLength:2 },
      },
      {
        name: "total_user",
        label: "Total Users",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true,maxLength:2 },
      },
      {
        name: "user_prefix",
        label: "User Prefix",
        type: "text",
        // required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
      },
    ]
  
    
  
    const CustomerInputsAfterSuccess = [
      {
        name: "adhaarcard",
        label: "Adhaar Card",
        type: "file",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      {
        name: "pan",
        label: "Pan Card",
        type: "file",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      {
        name: "cancelcheque",
        label: "Cancel Cheque",
        type: "file",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      {
        name: "agreementcopy",
        label: "Agreement Copy",
        type: "file",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      {
        name: "businesslicense",
        label: "Business Licence & Permits",
        type: "file",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      {
        name: "environmentalpolicy",
        label: "Environment Policy",
        type: "file",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      // {
      //   name: "accessModule",
      //   label: "Access Module",
      //   type: "multiselectdropdown",
      //   options: menuDropdown,
      //   required: true,
      //   gridClass: "col-lg-4",
      // isVisible: false
      // },
      // {
      //   name: "remark",
      //   label: "Remarks",
      //   type: "text",
      //   required: true,
      //   gridClass: "col-lg-4",
      // isVisible: false
      // },
    ];
  
  
    const AccessModule = [
      ...(!isBpApproved
        ? [
          {
            name: "onboard_level",
            label: "Action",
            required: true,
            type: "dropdown",
            options: [
              { label: "Update", value: 2},
              { label: "Approve", value: 3 },
            ],
            gridClass: "col-lg-4",
            validation: { required: true },
          },
          ]
        : []),
     
      {
        name: "accessModule",
        label: "Access Module",
        type: "multiselectdropdown",  
        options: menuDropdown,
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      {
        name: "remark",
        label: "Remarks",
        type: "text",
        placeholder:"Enter Remark",
        // required: true,
        gridClass: "col-lg-4",
      },
    ]
  
    const CustomerInputs = [
      // {
      //   name: "onboard_process_type",
      //   label: "On Board Business Type",
      //   type: "text",
      //   required: true,
      //   gridClass: "col-lg-4",
      //   validation: { required: true },
      // },
      {
        name: "bp_type",
        label: "Business Partner Type",
        type: "dropdown",
        required: true,
        options: businessPartnertypedd,
        // options: [
        //   { label: "OEM", value: "OEM" },
        //   { label: "OEM2", value: "OEM2" },
        // ],
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      {
        name: "bp_name",
        label: "Business Partner Name",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true, maxLength:50 },
      },
      {
        name: "contact_no",
        label: "Contact No.",
        type: "number",
        required: true,
        gridClass: "col-lg-4",
        validation: { 
          required: true, pattern: /^[6-9]/ ,
          minLength:10,
          maxLength:10,
          message1: "Contact no should start with 6, 7, 8, 9",
          message: "Please enter a valid 10-digit",
        }
      },
      {
        name: "email_id",
        label: "Email Address",
        type: "email",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      {
        name: "bp_address",
        label: "Business Partner Address",
        type: "text",
        required: false,
        gridClass: "col-lg-4",
        validation: { required: true ,maxLength:50},
      },
      {
        name: "pincode",
        label: "Pin Code",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true,responseerror:responseerrormessage },
      },
      {
        name: "city",
        label: "City",
        type: "text",
        disabled:true,
        required: false,
        gridClass: "col-lg-4",
       // validation: { required: true },
      },
      {
        name: "state",
        label: "State",
        type: "text",
        disabled:true,
        required: false,
        gridClass: "col-lg-4",
        
        //validation: { required: true },
      },
      {
        name: "country",
        label: "Country",
        type: "text",
        required: false,
        gridClass: "col-lg-4",
        disabled:true,
       // validation: { required: true },
      },
      {
        name: "gst_no",
        label: "GST No.",
        type: "text",
        // required: true,
        gridClass: "col-lg-4",
        validation: { required: false },
      },
      {
        name: "status",
        label: "Status",
        type: "dropdown",
        required: true,
        options: [
          { label: "Active", value: 1 },
          { label: "Inactive", value: 0},
        ],
        gridClass: "col-lg-4",
        validation: { required: true },
      },
      // {
      //   name: "action",
      //   label: "Action",
      //   required: true,
      //   type: "dropdown",
      //   options: [
      //     { label: "New", value: "New" },
      //     // { label: "Update", value: "Update" },
      //     // { label: "Approve", value: "Approve" },
      //   ],
      //   gridClass: "col-lg-4",
      //   validation: { required: true },
      // },
    ];
  
   
  
  
    const handleSectionChange = (section) => {
      setActiveSection(section);
    };
  
    
  
    const backNavigate = () => {
      navigate("/admin/manage-onboard/onboard")
    }
  
    return (
      <>
        <ToastContainer />
        <div className="backbutton mt-2 mb-2">
          <img onClick={backNavigate} src={backicon} alt="back" />
          {
            onboardProcessType === "customer" ?
            <span className="backbtntitle">Update Business Partner</span>
            :
            <span className="backbtntitle">Update Business Partner</span>
          }
          {/* {onboardProcessType === 'customer' ? 'Update Customer' : 'Update Agent'} */}
        </div>
        <div className="form-container">
          <div style={{display:"flex", gap:"10px"}}>
      
          </div>
         
          <DynamicForm
            formConfig={CustomerInputs}
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleFormSubmit}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            setResponseErrorMessage={setResponseErrorMessage}
          />
       {/* <div style={{paddingTop:"15px"}} onClick={()=> updateForm(formData)}  className="agentSubmit-btn">
              Submit
            </div> */}
          <>
            <div>
              <span className="backbtntitle">Configuration</span>
              <DynamicForm
                formConfig={ConfigInputs}
                formData={configformData}
                setFormData={setConfigformdata}
                onSubmit={handleConfig}
               
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            
            </div>
            <div className="pt-4">
              <span className="backbtntitle">Upload Documents and Details</span>
              <p class="glassmorphism-message">Please select at least one document. If a document is already selected, you may ignore this message.</p>
              <DynamicForm
    
          formConfig={CustomerInputsAfterSuccess}
          formData={uploadDocumentFormData}
          setFormData={setuploadDocumentFormData}
          onSubmit={handleFormSubmit}
          images={images}
          setImages={setImages}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
  
              <DynamicForm
                formConfig={AccessModule}
                formData={accessModule}
                setFormData={setAccessModule}
                onSubmit={handleFormSubmit}
               
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
  
        
        {/* [
            ...CustomerInputsAfterSuccess,
            ...(showAdditionalInputs
              ? [
                  {
                    name: "accessModule",
                    label: "Access Module",
                    type: "multiselectdropdown",
                    options: menuDropdown,
                    required: true,
                    gridClass: "col-lg-4",
                  },
                  {
                    name: "remark",
                    label: "Remarks",
                    type: "text",
                    required: true,
                    gridClass: "col-lg-4",
                  },
                ]
              : []),
          ] */}
  
        {/* <DynamicForm 
        // formConfig={CustomerInputsAfterSuccess.map(input => {
        //   if (input.name === "accessModule") {
        //     // console.log("leadsourceformdata",formData);
        //     return {
        //       ...input,
        //       isVisible: formData.action === 2, // Check if leadsource is 'ref'
        //     };
        //   }
        //   return input;
        // }) }
        formData={uploadDocumentFormData}
          setFormData={setuploadDocumentFormData}
          onSubmit={uploadDocumentForm}
          images={images}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        /> */}
            </div>
  
          </>
            
          <div onClick={()=> handleConfig(configformData)}  className="agentSubmit-btn">
              Submit
            </div>
        </div>
  
      </>
    );
  };
  
  export default EditAgentCustomerForm;
  